import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
class AppointmentWindow extends Component {
    constructor() {
        super(...arguments);
        this.handleSameDayWindowChange = (momentDateObj) => {
            if (!momentDateObj) {
                this.props.onAppointmentChange({
                    window_start: null,
                    window_end: null,
                    appointment: false,
                });
                return;
            }
            const window_start = momentDateObj.startOf('day').toISOString();
            const window_end = momentDateObj.endOf('day').toISOString();
            this.props.onAppointmentChange({
                window_start,
                window_end,
                appointment: false,
            });
        };
        this.handleWindowStartChange = (momentDateObj) => this.props.onWindowStartChange(getDateValue(momentDateObj));
        this.handleWindowEndChange = (momentDateObj) => this.props.onWindowEndChange(getDateValue(momentDateObj));
        this.handleEnableAppointmentTimes = () => this.props.onEnableAppointmentTimes();
    }
    getValidationClass(field) {
        const { status } = this.props;
        if (field === 'all') {
            return {
                error: status.window_start || status.window_end,
            };
        }
        return {
            error: status[field],
        };
    }
    renderSameDayWindow() {
        const { t } = this.props;
        const className = classnames(Object.assign({ flex: true, 'items-center': true }, this.getValidationClass('all')));
        return (React.createElement("div", { className: className },
            React.createElement("div", { className: "mr-2" },
                React.createElement(DatePicker, { selected: this.props.window_start, className: "form-field w-full", onChange: this.handleSameDayWindowChange, placeholderText: t('ENTER_A_DATE'), isClearable: true })),
            React.createElement("button", { type: "button", title: t('ADD_APPOINTMENT'), onClick: this.handleEnableAppointmentTimes, className: "flex items-center" },
                React.createElement("i", { className: "fa fa-plus-circle mr-1 text-grey-darker" }),
                React.createElement("small", { className: "text-xs text-grey-darker" }, titleize(t('APPOINTMENT'))))));
    }
    renderSeparateDayWindows() {
        const windowStartClass = classnames(Object.assign({ 'datepicker-wrapper': true, 'mr-2': true }, this.getValidationClass('window_start')));
        const windowEndClass = classnames(Object.assign({ 'datepicker-wrapper': true }, this.getValidationClass('window_end')));
        const { t } = this.props;
        return (React.createElement("div", { className: "flex items-center" },
            React.createElement("div", { className: windowStartClass },
                React.createElement(DatePicker, { selected: this.props.window_start, className: "form-field w-full", placeholderText: t('ENTER_START_OF_WINDOW'), showTimeSelect: true, dateFormat: "L LT", timeIntervals: 30, timeCaption: t('WINDOW_TIME'), isClearable: true, onChange: this.handleWindowStartChange, onSelect: this.handleWindowStartChange })),
            React.createElement("div", { className: windowEndClass },
                React.createElement(DatePicker, { selected: this.props.window_end, className: "form-field w-full", placeholderText: t('ENTER_END_OF_WINDOW'), showTimeSelect: true, dateFormat: "L LT", timeIntervals: 30, timeCaption: t('WINDOW_TIME'), isClearable: true, onChange: this.handleWindowEndChange, onSelect: this.handleWindowEndChange }))));
    }
    render() {
        if (this.props.appointment) {
            return this.renderSeparateDayWindows();
        }
        return this.renderSameDayWindow();
    }
}
AppointmentWindow.propTypes = {
    appointment: PropTypes.bool,
    window_start: PropTypes.instanceOf(moment),
    window_end: PropTypes.instanceOf(moment),
    status: PropTypes.object,
    onWindowStartChange: PropTypes.func.isRequired,
    onWindowEndChange: PropTypes.func.isRequired,
    onAppointmentChange: PropTypes.func.isRequired,
    onEnableAppointmentTimes: PropTypes.func.isRequired,
};
function getDateValue(momentDateObj) {
    if (momentDateObj) {
        return momentDateObj.toISOString();
    }
    return null;
}
export default withTranslation()(AppointmentWindow);
